"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftArrow = void 0;
var react_1 = __importDefault(require("react"));
function LeftArrow(props) {
    return (react_1.default.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 30, height: 30, viewBox: "0 0 30 30" }),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { id: "linear-gradient", x1: 0.281, y1: 0.765, x2: 1, gradientUnits: "objectBoundingBox" },
                react_1.default.createElement("stop", { offset: 0, stopColor: "#2994ff" }),
                react_1.default.createElement("stop", { offset: 1, stopColor: "#2f57ff" }))),
        react_1.default.createElement("g", { id: "Group_48190", "data-name": "Group 48190", transform: "translate(13764 11600)" },
            react_1.default.createElement("g", { id: "Group_48186", "data-name": "Group 48186", transform: "translate(428 7)" },
                react_1.default.createElement("rect", { id: "Rectangle_25783", "data-name": "Rectangle 25783", width: 30, height: 30, transform: "translate(-14192 -11607)", fill: "none" })),
            react_1.default.createElement("path", { id: "Icon_material-keyboard-arrow-right", "data-name": "Icon material-keyboard-arrow-right", d: "M24,24.51l-6.87-6.885L24,10.74,21.885,8.625l-9,9,9,9Z", transform: "translate(-13767.885 -11602.625)", fill: "url(#linear-gradient)" }))));
}
exports.LeftArrow = LeftArrow;
//# sourceMappingURL=LeftArrow.js.map